/**
 * Entry Point — initializes all modules and wires the DJ console
 * Fix: DOMContentLoaded listener was previously missing; the app never started.
 */

import { AudioEngine  } from './audio-engine.js'
import { StateManager } from './state.js'
import { StorageManager } from './storage.js'
import { DeckController } from './deck.js'
import { Visualizer   } from './visualizer.js'
import { MixAnalyzer  } from './mix-analyzer.js'
import { PlaylistManager } from './playlist-manager.js'
import { initializeUI } from './ui.js'
import { initializeMobileUI } from './mobile-ui.js'

async function initializeApp() {
  console.log('🎛  DJ Pro Studio — initializing...')

  // Core services
  const state   = new StateManager()
  const storage = new StorageManager()
  const engine  = new AudioEngine(state)

  // Deck controllers (own per-deck playback logic)
  const deckA = new DeckController('A', engine, state)
  const deckB = new DeckController('B', engine, state)

  // Waveform visualizers (start render loops immediately)
  const vizA = new Visualizer('waveform-a', engine.analysers['A'], 'A', deckA)
  const vizB = new Visualizer('waveform-b', engine.analysers['B'], 'B', deckB)
  vizA.startLoop()
  vizB.startLoop()

  // Mix analyzer (for key detection, energy, compatibility scoring)
  const analyzer = new MixAnalyzer(engine.ctx)

  // Playlists for each deck
  const playlistA = new PlaylistManager('A')
  const playlistB = new PlaylistManager('B')

  // Desktop UI — binds all 45+ controls, drag-drop, auto-mix, time display
  initializeUI({ engine, state, storage, deckA, deckB, vizA, vizB, analyzer, playlistA, playlistB })

  // Mobile UI — simplified 2-deck + auto-mix, touch devices only
  initializeMobileUI({ engine, deckA, deckB, analyzer, playlistA, playlistB })

  console.log('✅ DJ Pro Studio ready — drop tracks to begin')
}

document.addEventListener('DOMContentLoaded', initializeApp)
